import { render, staticRenderFns } from "./Interpolator.vue?vue&type=template&id=67bef783&scoped=true&"
import script from "./Interpolator.vue?vue&type=script&lang=js&"
export * from "./Interpolator.vue?vue&type=script&lang=js&"
import style0 from "./Interpolator.vue?vue&type=style&index=0&id=67bef783&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bef783",
  null
  
)

export default component.exports